module.exports = __webpack_public_path__ + "static/bcc-8a2694f3e712f02a76ce1878ca5c1c34.webm";